import React, { useEffect, useState } from "react";

export const MARKETING_HEADLINES = [
  "Your next great night starts here.",
  "Make tonight a story worth sharing.",
  "Ghana’s best events are one ticket away.",
  "Find your people. Feel the moment.",
  "The night you’ll remember starts here.",
  "See what’s happening. Be there.",
];

export default function RotatingMarketingHeadline() {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % MARKETING_HEADLINES.length);
    }, 60_000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <span key={MARKETING_HEADLINES[index]} className="icaard-marketplace-headline" data-testid="marketing-headline">
      {MARKETING_HEADLINES[index]}
    </span>
  );
}
